<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header mrb-90">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">Services</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/services" class="h5 text-white">Our Services</a>
        </div>
    </div>
</div>

<!-- Service Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Our Services</h5>
            <h1 class="mb-0">Creative Solutions to Elevate Your Brand Identity</h1>
        </div>
        <div class="row g-5">
            <!-- Services -->
            <div class="col-lg-4 col-md-6" *ngFor="let service of services">

                <div class="service-item bg-light border-radius d-flex flex-column align-items-center justify-content-center text-center">
                    <div class="service-icon border-radius">
                        <i class="bi text-white" [ngClass]="service.icon"></i>
                    </div>
                    <h4 class="mb-3">
                        {{service.title}}
                    </h4>
                    <p class="m-0">
                        {{service.desc}}
                    </p>
                    <a class="btn btn-lg btn-primary border-radius" routerLink="/services">
                        <i class="bi bi-arrow-right"></i>
                    </a>
                </div>

            </div>
            <!-- CTA Card -->
            <div class="col-lg-4 col-md-6">
                <div class="position-relative bg-primary border-radius h-100 d-flex flex-column align-items-center justify-content-center text-center p-5">
                
                <h3 class="text-white mb-3">Let's Work Together</h3>
                
                <p class="text-white mb-3">
                    Let us bring your brand vision to life with thoughtful design and creative storytelling.
                </p>
                
                <h2 class="text-white mb-0">
                    +1 300 1234567
                </h2>

                </div>
            </div>
        </div>
    </div>
</div>
<!-- Service End -->

<!-- Testimonial Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-4 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Testimonials</h5>
            <h1 class="mb-0">What Our Clients Say About Working With Us</h1>
        </div>
        <owl-carousel-o [options]="testimonialCarousel" class="owl-btn-center-lr testimonial-carousel mrt-80">
          <ng-template carouselSlide *ngFor="let client of clients">
            <!-- Testimonial box -->
            <div class="testimonial-item bg-light">
                <div class="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                    <img class="img-fluid border-radius" src="assets/images/{{client.image}}"
                        style="width: 60px; height: 60px;" alt="client-1">
                    <div class="ps-4">
                        <h4 class="text-primary mb-1">{{client.title}}</h4>
                        <small class="text-uppercase">{{client.subtitle}}</small>
                    </div>
                </div>
                <div class="pt-4 pb-5 px-5">
                    {{client.desc}}
                </div>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div>
<!-- Testimonial End -->

<!-- Brands Start -->
<div class="container-fluid">
    <div class="container py-5 mb-5">
        <div class="bg-white">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr vendor-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a href="#."><img src="assets/images/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- Brands End -->